module.exports = ol.style.Icon;